<template>
  <div class="comp-question-item un-select" :class="{'bg-gray': isInBasket && !showDel}" :id="'Ques'+item.testID">
    <div class="item-top flex-between p15" :class="{'bb-1px': isInBasket}">
      <div class="top-left flex-row-center">
        <div class="mr20">题号：<span class="f12 text-color-2">{{item.testID}}</span></div>
        <div class="mr20">题型：<span class="f12 text-color-2">{{item.typesName}}</span></div>
        <div class="mr20">难度：<span class="text-orange">{{item.diffName}}</span></div>
        <div class="mr20">日期：<span class="text-orange">{{item.loadTime | formatTimeDate}}</span></div>
        <div class="mr20" v-if="showSaveBox">收藏夹：<span class="text-orange">{{catalogNameMap[item.catalogID]}}</span></div>
      </div>
      <div class="flex-row-center top-right">
        <div class="mr15 cur-poi" v-if="showGrade" v-before="{handler: bindGradeQues}"><span class="iconfont icongaifen text-color-3"></span> 评分</div>
        <div class="mr15 cur-poi" v-if="showError" v-before="{handler: bindErrQues}"><span class="iconfont iconjiucuo text-color-3"></span> 纠错</div>
        <div class="mr15 cur-poi" v-if="showMove" v-before="{handler: bindMoveTest}"><span class="iconfont iconyidongwenjian text-color-3"></span> 移动试题</div>
        <template v-if="showCollect && !itemSource">
          <div class="cur-poi text-primary" v-if="item.collectID > 0" v-before="{handler: bindCollectCancelQues}"><span class="iconfont iconshitishoucang"></span> 取消收藏</div>
          <div class="cur-poi" v-else v-before="{handler: bindCollectQues}"><span class="iconfont iconshoucang text-color-3"></span> 收藏试题</div>
        </template>
        <!--如果item是计算属性，启用itemsource，原始数据-->
        <template v-if="showCollect && itemSource">
          <div class="cur-poi text-primary" v-if="itemSource.collectID > 0" v-before="{handler: bindCollectCancelQues}"><span class="iconfont iconshitishoucang"></span> 取消收藏</div>
          <div class="cur-poi" v-else v-before="{handler: bindCollectQues}"><span class="iconfont iconshoucang text-color-3"></span> 收藏试题</div>
        </template>
        <!--用于试题篮的查看试题-->
        <div class="mr15 cur-poi" v-if="showDel" @click="bindRemovePaper"><span class="iconfont iconshanchu text-color-3"></span> 移除试题</div>
      </div>
    </div>
    <div class="item-test p15 cur-poi" @click="bindAnalysisModuleShow" :class="{'pb1': showBtns}">
      <div class="source f12 mb15 mt5">来源：<span class="source-name">{{item.docName}}</span></div>
      <div class="test-text lh17" v-html="itemOpr.test"></div>
    </div>
    <div class="btns tr p15 pt5" v-if="showBtns">
      <el-button type="primary" v-before="{handler: bindSingleDown}"><span class="iconfont iconxiazai"></span> 单题下载</el-button>
      <el-button type="danger" v-if="isInBasket" v-before="{handler: bindRemovePaper}">移除试题</el-button>
      <el-button type="primary" v-else v-before="{handler: bindAddPaper}">加入试卷</el-button>
    </div>
    <div class="item-bottom bt-1px p15" v-show="copyItem._anaModule">
      <div class="analysis-text lh17" v-show="copyItem._analysis && isLogin">
        <div v-if="item.answer">
          <div class="text-primary ml-5">【答案】</div>
          <div class="lh17 mt10 mb15" v-html="itemOpr.answer"></div>
        </div>
        <div class="bt1-dash pt15" v-if="item.analytic">
          <div class="text-primary ml-5">【解析】</div>
          <div class="lh17 mt10 mb15" v-html="itemOpr.analytic"></div>
        </div>
        <div class="bt1-dash pt15" v-if="item.klList && item.klList.length">
          <div class="text-primary ml-5">【知识点】</div>
          <div class="lh17 mt10 mb15">
            <div v-for="(item1, index) in item.klList" :key="index">{{item1}}</div>
          </div>
        </div>
        <div class="bt1-dash pt15" v-if="item.remark && item.remark !== '<p>无</p>'">
          <div class="text-primary ml-5">【备注】</div>
          <div class="lh17 mt10" v-html="item.remark"></div>
        </div>
      </div>
      <div v-if="!isLogin">请<span class="text-primary cur-poi" @click="goLogin">[登录]</span>后查看答案及解析</div>
      <div v-if="showToggle && isLogin" class="text-primary cur-poi tr" @click="bindAnalysisShow()">{{copyItem._analysis ? '隐藏答案' : '显示答案'}} <span :class="{'rotate-180': copyItem._analysis}" class="iconfont iconxialazhankai"></span></div>
    </div>
  </div>
</template>

<script>
  /*!*
   * @author yueheqin
   * @date 2019/7/3
   * @project zujuanzaixian
   * @desc
   */
  import {downloadMixin} from '../../mixins/zj-common'
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  import { renderMathML } from '../../views/utils/render-mathml'
  /**
   * @desc 计算试题列表中的题号
   * @todo 该方法有待测试和优化 英语题号有问题，跳转也有问题 eg/paperdetail?prePage=mxmj&docID=71242    71-80
   * @params list [array] testList
   */
  let xtRE = /(【小题】)/g
  let thRE = /(【题号】)/g

  function countTestListOrder (itm) {
    let item = JSON.parse(JSON.stringify(itm))
    if (item.testNum == 1) return item
    let currentOrder = 0
    item._order = []
    let rIndex = -1
    let temp = currentOrder
    // 替换 【小题】
    if (xtRE.test(item.test)) {
      item.test = item.test.replace(xtRE, () => {
        currentOrder++
        item._order.push(currentOrder)
        return `<strong id="question-order-${currentOrder}"> ${currentOrder}.</strong>`
      })
    }
    if (xtRE.test(item.answer)) {
      currentOrder = temp
      item.answer = item.answer.replace(xtRE, () => {
        currentOrder++
        item._order.push(currentOrder)
        return `<strong> ${currentOrder}. </strong>`
      })
    }
    if (xtRE.test(item.analytic)) {
      currentOrder = temp
      item.analytic = item.analytic.replace(xtRE, () => {
        currentOrder++
        item._order.push(currentOrder)
        return `<strong> ${currentOrder}. </strong>`
      })
    }

    // // 替换 【题号】
    if (thRE.test(item.test)) {
      rIndex = -1
      item.test = item.test.replace(thRE, () => {
        rIndex++
        let order = item._order[rIndex] || currentOrder++
        return `<strong> ${order} </strong>`
      })
    }
    return item
  }
  export default {
    name: 'comp-question-item',
    mixins: [downloadMixin],
    props: {
      item: { // 单道题数据
        type: Object,
        required: true
      },
      itemSource: { // 如果传入的item是计算属性，此属性为原始数据，用于收藏等操作处理
        type: Object
      },
      showCollect: { // 收藏
        type: [Boolean, String],
        default () {
          return true
        }
      },
      showMove: { // 移动
        type: [Boolean, String],
        default () {
          return false
        }
      },
      showGrade: { // 评分
        type: [Boolean, String],
        default () {
          return false
        }
      },
      showError: { // 纠错
        type: [Boolean, String],
        default () {
          return false
        }
      },
      showBtns: { // 下载和加入试题按钮
        type: [Boolean, String],
        default () {
          return true
        }
      },
      showToggle: { // 隐藏显示解析
        type: [Boolean, String],
        default () {
          return true
        }
      },
      page: {
        type: String
      },
      hasOrder: { // 是否已经计算过题号，试题预览页面计算过
        type: Boolean,
        default () {
          return false
        }
      },
      showSaveBox: { // 是否显示收藏夹
        type: [Boolean, String],
        default () {
          return false
        }
      },
      showDel: { // 是否显示删除，仅用于试题篮的查看试题
        type: [Boolean, String],
        default () {
          return false
        }
      }
    },
    data () {
      return {
        copyItem: null
      }
    },
    computed: {
      ...mapGetters('user', ['isLogin']),
      ...mapGetters('basket', ['quesBasket']),
      ...mapGetters('common', ['currentSubject', 'catalogNameMap']),
      subjectID () {
        return this.currentSubject.id
      },
      isInBasket () {
        let quesBasketSubject = this.quesBasket[this.subjectID]
        return !!(quesBasketSubject && quesBasketSubject[this.item.testID])
      },
      itemOpr () {
        let item = JSON.parse(JSON.stringify(this.item))
        this.$nextTick(() => {
          renderMathML()
        })
        return this.hasOrder ? item : countTestListOrder(item)
      },
      isUserQues () {
        return this.$route.name === 'UserQues'
      }
    },
    watch: {
      item: {
        handler (n, o) {
          let vm = this
          if (!vm.copyItem) {
            vm.copyItem = JSON.parse(JSON.stringify(n))
          }
          if (!_.has(vm.copyItem, '_analysis')) {
            vm.$set(vm.copyItem, '_analysis', false)
          }
          if (!_.has(vm.copyItem, '_anaModule')) {
            vm.$set(vm.copyItem, '_anaModule', false)
          }
        },
        immediate: true
      }
    },
    methods: {
      ...mapMutations('common', ['goLogin']),
      ...mapMutations('pop', ['updateCurrentQues', 'updateCurrentQuesCB', 'updateGradePopVisible', 'updateCorrectPopVisible', 'updateCollectPopVisible']),
      ...mapMutations('basket', ['addQuesBasket', 'removeQuesBasket']),
      ...mapActions('zujuan', ['collectQues', 'collectQuesCancel', 'singleDown']),
      // 单击试题操作（显示隐藏解析模块）
      bindAnalysisModuleShow () {
        if (this.copyItem._anaModule) {
          _.assign(this.copyItem, {_anaModule: false})
        } else {
          _.assign(this.copyItem, {_anaModule: true, _analysis: true})
          this.$nextTick(() => {
            renderMathML()
          })
        }
      },
      // 单击隐藏或显示答案操作（显示隐藏答案）
      bindAnalysisShow () {
        this.copyItem._analysis = !this.copyItem._analysis
        this.$nextTick(() => {
          renderMathML()
        })
      },
      bindShowAnswer (val) {
        _.assign(this.copyItem, {_anaModule: val, _analysis: val})
        this.$nextTick(() => {
          renderMathML()
        })
      },
      // 移动试题
      bindMoveTest () {
        this.$emit('bindMoveTest', this.item)
      },
      // 收藏试题
      bindCollectQues () {
        let item = this.itemSource ? this.itemSource : this.item
        this.updateCurrentQues(item)
        this.updateCollectPopVisible(true)
      },
      // 取消收藏试题
      bindCollectCancelQues () {
        let vm = this
        let item = vm.itemSource ? vm.itemSource : vm.item
        let payload = {
          params: {
            collectID: item.collectID
          },
          config: {
            loading: '#Ques' + item.testID
          }
        }
        if (vm.isUserQues) {
          vm.$emit('bindRemoveTest', item)
        } else {
          vm.collectQuesCancel(payload).then(res => {
            vm.$emit('update:item', _.assign(item, {collectID: 0}))
            vm.$notify.success({
              title: '提示',
              message: '取消收藏成功'
            })
          })
        }
      },
      // 单题下载
      bindSingleDown () {
        let payload = {
          data: {
            testID: this.item.testID
          },
          config: {
            loading: '#Ques' + this.item.testID
          }
        }
        this.singleDown(payload).then(res => {
          this.download(res.data.docPath)
        })
      },
      // 加入试卷
      bindAddPaper () {
        if (this.item.subjectID != this.subjectID) {
          this.$message.error('当前试题学科与所选学科不一致，请切换学科之后添加试题！')
          return
        }
        this.addQuesBasket(this.item)
      },
      // 移除试题
      bindRemovePaper () {
        if (this.item.subjectID != this.subjectID) {
          this.$message.error('当前试题学科与所选学科不一致，请切换学科之后移除试题！')
          return
        }
        this.removeQuesBasket(this.item)
      },
      // 试题评价
      bindGradeQues () {
        this.updateCurrentQues(this.item)
        this.updateGradePopVisible(true)
      },
      // 试题纠错
      bindErrQues () {
        this.updateCurrentQues(this.item)
        this.updateCorrectPopVisible(true)
      }
    }
  }
</script>

<style lang="less">
  @import "../../styles/_mixins-wln";
  .comp-question-item {
    &.bg-gray{
      background: #FAFAFA;
    }
    .bt1-dash{
      border-top: 1px dashed @border-color-3;
    }
    .rotate-180{
      transform: rotate(180deg);
    }
    border: 1px solid @border-color-3;
    margin-bottom: 15px;
    &:hover{
      border-color: @primary;
      .source-name{
        color: @primary;
      }
    }
    .item-top{
      background: #FAFAFA;
      padding: 15px;
      .top-right>div:hover{
        color: @primary;
        .iconfont{
          color: @primary;
        }
      }
    }
    .item-test{
    }
    .item-bottom{
      .iconxialazhankai{
        display: inline-block;
        transition: transform 0.3s;
      }
    }
    .el-button--danger {
      color: #FFF;
      background-color: @orange;
      border-color: @orange;
    }
  }
</style>
